import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
} from '@angular/forms';

import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    FeatureValues,
    IFeatureSetting,
    ModalResultType,
} from '@models';

import { FeaturesService } from '@services';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    templateUrl: './feature-flags.modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./feature-flags.modal.scss'],
})
export class FeatureflagsModalComponent extends UiModalComponent<{
    tenantIds: number[],
    features: Record<string, IFeatureSetting | null>,
}> implements OnInit {
    public FeatureValues = FeatureValues;
    public form!: FormGroup;
    public loading$ = new BehaviorSubject(false);

    public get featureKeys() {
        return Object.keys(this.form.controls);
    }

    public get features() {
        return this.context.data.features;
    }

    private _featuresService = this._injector.get<FeaturesService>(FeaturesService);

    ngOnInit() {
        const fb = this._injector.get<FormBuilder>(FormBuilder);

        const formControls = Object.keys(this.context.data.features)
            .reduce(
                (acc: any, featureName) => {
                    if (this.context.data.features[featureName] != null) {
                        acc[featureName] = [{value: this.context.data.features[featureName]!.value,
                            disabled: !!this.context.data.features[featureName]!.notEditable }];
                    }

                    return acc;
                }, {});

        this.form = fb.group(formControls);
    }

    public onSubmit() {
        if (
            !this.form.dirty ||
            this.loading$.value
        ) {
            return;
        }

        this.loading$.next(true);
        this._saveFeatureFlags()
            .pipe(finalize(() => this.loading$.next(false)))
            .subscribe(() => {
                this._dialogRef.close({
                    type: ModalResultType.Update,
                });
            });
    }

    private _saveFeatureFlags() {
        const payload = cloneDeep(this.form.value);

        this.featureKeys
            .forEach(controlKey => {
                if (!this.form.get([controlKey])!.dirty) {
                    delete payload[controlKey];
                }
            });

        return this._featuresService.updateFeatureFlags(payload, this.context.data.tenantIds);
    }
}
